/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-call */
export const initReleaseNotesModal = () => {
  (function (w, d, s, o, f, js, fjs) {
    w.ReleaseNotesWidget = o;
    w[o] =
      w[o] ||
        function () {
          // eslint-disable-next-line prefer-rest-params
          (w[o].q = w[o].q || []).push(arguments);
        };
    ((js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]));
    js.id = o;
    js.src = f;
    js.async = 1;
    fjs.parentNode.insertBefore(js, fjs);
  })(
    window,
    document,
    'script',
    'rnw',
    'https://s3.amazonaws.com/cdn.releasenotes.io/v1/bootstrap.js'
  );

  rnw('init', {
    account: 'icom-router-management.releasenotes.io',
    selector: '.rn-badge', // change the CSS selector to apply the badge and link to
    auto_show_unseen: true,
    max_release_age: 30
  });
};
